import { BASE_SSR_SET_DATA } from 'rebook/apps/base/constants';


const initialState = {
  headers: null,
  isRequested: false,
};

export default function ssr(state = initialState, action) {
  switch (action.type) {
    case BASE_SSR_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
